module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/ticket-2a84606efcc5626bd47d06ff31deab24.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/ticket.svg
// module id = 620
// module chunks = 0